import { useMemo } from "react";
import { AuditoinnitCacheKeys } from "../cacheKeys";
import { IAuditListFilters } from "../../interfaces/IAudit";
import { IPagination } from "../../interfaces/common/IPagination";
import { IAuditItem } from "../../interfaces/IAuditItem";
import { useAuditPage } from "./useAuditsPage";
import { useSWRCache } from "../../../sg-core/swr/useSWRCache";
import { useAuthContext } from "../../auth/AuthenticationProvider";

let count = 0;
export type IUseAuditPageHook = (pagination?: IPagination, filters?: Partial<IAuditListFilters>) => {
    data: IAuditItem[];
    pagination: IPagination;
    fetching: boolean;
    goToPage: (page: number) => void;
};

export const useAuditsPageItems: IUseAuditPageHook = (initialPg = { page: 1, pageSize: 20 }, filters = {}) => {
    const { data, fetching, pagination, goToPage } = useAuditPage(initialPg, filters);
    const { token, lang, anonymousSession } = useAuthContext();

    const { cache } = useSWRCache();
    const resolveItem = (id: number) => {
        const key = AuditoinnitCacheKeys(token, lang).AuditItemInstance(id);
        return cache.get(key);
    }

    const items = useMemo(() => {
        count = count + 1
        return data.map(resolveItem)
    }, [data, cache]); //eslint-disable-line

    const rawData = items;

    return useMemo(() => ({
        data: rawData,
        pagination,
        goToPage,
        fetching,
    }), [rawData, pagination, fetching, goToPage]);
};
